<template>
    <div class="sub-visual-wrap">
        <div class="sub-visual">
            <div class="sub-visual-tit">
                <v-container>
                    <h2 class="poppins">{{sh}}</h2>
                </v-container>
            </div>
            <div class="sub-visual-bg" :style="'background-image:url('+ bg +');'">
            </div>
        </div>
        <v-container>
            <client-gnb className="sub-tab-wrap" :tabActive="tabActive" :sh="sh" v-if="sh !== 'Contact'"></client-gnb>
        </v-container>
    </div>
</template>

<script>
import ClientGnb from "@/components/client/en/inc/client-gnb.vue";

export default{
    props : {
        sh : {type :String, default : ""},
        bg : {type :String, default : ""},
        tabActive : {type :String, default : ""},
    },
    components: {
        ClientGnb,
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.sub-visual{
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
}
.sub-visual-tit{
    position: relative;
    z-index: 1;
}
.sub-visual-tit h2{
    font-size: 3.6rem;
    line-height: 1.2;
    font-weight: 600;
    color: #fff;
}
.sub-visual-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

@media (min-width:576px){
}
@media (min-width:768px){
    .sub-visual{
        height: 280px;
    }
    .sub-visual-tit h2{
        font-size: 5rem;
    }
}
@media (min-width:1024px){
    .sub-visual{
        height: 480px;
    }
    .sub-visual-tit h2{
        font-size: 6.6rem;
    }
}
@media (min-width:1200px){
}

</style>